export default "<div id=\"div_credit_redirect\" style=\"text-align: center;\">\n\n</div>"